module.exports = __webpack_public_path__ + "mobile.30c81d83.png";